module.exports = __webpack_public_path__ + "static/media/converseLogo.17334d96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/converseLogo.svg
// module id = 700
// module chunks = 0